import React, { useState } from 'react';
import { ProductTypes } from '../../../../types/product/product';
import { sanitizeCalul } from '../../../../helpers/number/sanitizeCalul';
import { MainProductsFragment } from '../../../../graphql/generated/graphql';
import { CommandeLinePanier } from '../../../../types/commandeLine/commandeLine.def';
import { useDispatch, useSelector } from 'react-redux';
import { updatePanier as updatePanierAction } from '../../../../store/actions/panier.actions';
import { updatePanierCallback } from '../../../../helpers/panier/updatePanierCallback';
import { SingleProductPresentationView } from './SingleProductPresentation.view';
import { getChallengeStatus } from '../../../../store/selectors/user/user.selectors';

interface AddProductState {
  quantite: number;
  total: number;
  isValid: boolean;
  error: string;
  venterebond: boolean;
}

const initialState = (
  produit: Pick<MainProductsFragment, 'ttcPrice' | 'venterebond'>
): AddProductState => ({
  quantite: 1,
  total: produit.ttcPrice,
  isValid: true,
  error: '',
  venterebond: produit.venterebond
});

interface SingleProductPresentationProps {
  produit: ProductTypes;
  onClose?: () => void;
}

export const SingleProductPresentation = ({
  produit,
  onClose
}: SingleProductPresentationProps) => {
  const [state, setState] = useState<AddProductState>(initialState(produit));
  const dispatch = useDispatch();
  const { status } = useSelector(getChallengeStatus);
  const updatePanier = (payload: CommandeLinePanier) =>
    dispatch(updatePanierAction(payload));

  const handleChange = e => {
    if (e < 0) return null;
    const value = parseFloat(e);
    const tot = sanitizeCalul(produit.ttcPrice * value);

    return setState({
      ...state,
      quantite: value,
      total: tot,
      isValid: value > 0 && value < 1000,
      error: value > 1000 && 'Vous ne pouvez pas ajouter plus de 1000 produits'
    });
  };

  const handleSubmit = () => {
    updatePanier({
      produit: {
        id: produit.id,
        ref: produit.ref,
        media: [{ url: produit?.media[0]?.url }],
        name: produit.name,
        ttcPrice: produit.ttcPrice,
        venterebond: produit.venterebond
      },
      quantite: state.quantite,
      totalLine: state.total
    });
    return updatePanierCallback(
      produit,
      setState,
      initialState(produit),
      onClose
    ).onCompleted();
  };

  return (
    <SingleProductPresentationView
      handleChange={handleChange}
      disabled={!state.isValid || produit.isOut || status !== 'available'}
      value={state.quantite}
      produit={produit}
      handleSubmit={handleSubmit}
    />
  );
};
